import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'

import Registration from '@/views/Registration.vue'
import UserInfo from '@/views/Registration-UserInfo'
import CompanyInfo from '@/views/Registration-CompanyInfo'
import PaymentInfo from '@/views/Registration-PaymentInfo'
import InviteUsers from '@/views/Registration-InviteUsers'
import CarrierInfo from '@/views/Registration-CarrierInfo'
import AccountSettings from '@/views/AccountSettings'
// import DocumentUpload from '@/views/Registration-DocumentUpload'
import PasswordReset from '@/views/PasswordReset'

import Portal from '@/views/Portal'
import Dashboard from '@/views/logged-in/Dashboard'
import TransactionNew from '@/views/logged-in/Transactions-New'
import TransactionDetails from '@/views/logged-in/Transaction-Details'
import TransactionDetailsPublic from '@/views/PublicTransactionInfo'
import RolodexLocation from '@/views/logged-in/AddressBook'

import DocumentList from '@/views/logged-in/DocumentLibrary'
import ShipperApprovals from '@/views/logged-in/Factoring-Companies'
import CarrierApprovals from '@/views/logged-in/Factoring-Carriers'
import CarrierProfile from '@/views/CarrierProfile'
import ShipperCompanyProfile from '@/views/ShipperCompanyProfile'
import CarrierPerks from '@/views/CarrierPerks'

import RememberMe from '@/helpers/remember-me'
import Store from './store/index'

import beforeEnterPortal from '@/helpers/router-helpers/setupInternalAccess'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    // ref: https://router.vuejs.org/guide/advanced/scroll-behavior.html#scroll-behavior
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      async beforeEnter(to, from, next) {
        const userCreds = await RememberMe.getCreds()

        if (userCreds) {
          try {
            await Store.dispatch('user/authenticate', userCreds)
            next({ name: 'dashboard' })
          } catch (error) {
            // auth failed, so send them back to the login page
            next()
          }
        } else {
          // no creds saved, so just continue to login
          next()
        }
      },
      meta: {
        isPublic: true
      }
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: PasswordReset,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/tracking/:companyJobKey',
      name: 'transaction-details-public-',
      component: TransactionDetailsPublic,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/shipper-registration',
      component: Registration,
      meta: {
        isPublic: true
      },
      children: [
        {
          path: '',
          name: 'shipper-registration-userinfo',
          component: UserInfo,
          props: { accountType: 'shipper' },
          meta: {
            isPublic: true,
            displayName: 'account information'
          }
        },
        {
          path: 'company-info',
          name: 'shipper-registration-companyinfo',
          component: CompanyInfo,
          meta: {
            displayName: 'company information'
          }
        },
        {
          path: 'payment-info',
          name: 'shipper-registration-paymentinfo',
          component: PaymentInfo,
          meta: {
            displayName: 'billing information'
          }
        }

        /*
        {
          path: '',
          name: 'registration-document-upload',
          component: DocumentUpload,
          meta: {
            isPublic: true,
            displayName: 'company document upload'
          }
        },
        {
          path: 'invitation',
          name: 'registration-invite',
          component: InviteUsers,
          meta: {
            displayName: 'invite colleagues'
          }
        }
        */
      ]
    },
    {
      path: '/carrier-registration',
      component: Registration,
      meta: {
        isPublic: true
      },
      children: [
        {
          path: '',
          name: 'carrier-registration-userinfo',
          component: UserInfo,
          props: { accountType: 'carrier' },
          meta: {
            isPublic: true,
            displayName: 'account information'
          }
        },
        {
          path: 'carrier-info',
          name: 'carrier-registration-carrierinfo',
          component: CarrierInfo,
          meta: {
            isPublic: true,
            displayName: 'carrier information'
          }
        }
      ]
    },
    /*
    {
      path: '/registration-truckl-admin',
      component: Registration,
      meta: {
        isPublic: true
      },
      children: [
        {
          path: '',
          name: 'registration-userinfo-truckl-admin',
          component: UserInfo,
          props: { accountType: 'truckl-admin' },
          meta: {
            isPublic: true,
            displayName: 'account information'
          }
        }
      ]
    },
    */
    { path: '/registration', redirect: { name: 'shipper-registration-userinfo' } },
    {
      path: '/factoring-registration',
      component: Registration,
      meta: {
        isPublic: true
      },
      children: [
        {
          path: '',
          name: 'registration-userinfo-factoring',
          component: UserInfo,
          props: { accountType: 'factoring' },
          meta: {
            isPublic: true,
            displayName: 'account information'
          }
        },
        {
          path: 'invitation',
          name: 'registration-invite-factoring',
          component: InviteUsers,
          meta: {
            displayName: 'invite colleagues'
          }
        }
      ]
    },
    {
      path: '/registration-recipient',
      component: Registration,
      meta: {
        isPublic: true
      },
      children: [
        {
          path: '',
          name: 'registration-userinfo-recipient',
          component: UserInfo,
          props: { accountType: 'recipient' },
          meta: {
            isPublic: true,
            displayName: 'account information'
          }
        }
      ]
    },
    {
      path: '/portal',
      name: '',
      component: Portal,
      beforeEnter: beforeEnterPortal,
      children: [
        {
          path: '',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/address-book',
          name: 'address-book',
          component: RolodexLocation
        },
        {
          path: 'carrier/:accountKey',
          name: 'carrier-profile',
          component: CarrierProfile
        },
        {
          path: 'shipper/:companyKey',
          name: 'shipper-company-profile',
          component: ShipperCompanyProfile
        },
        {
          path: '/pending-approvals-carriers',
          name: 'factoring-carrier-approvals',
          component: CarrierApprovals
        },
        {
          path: '/pending-approvals-shippers',
          name: 'factoring-shipper-approvals',
          component: ShipperApprovals
        },
        {
          path: '/document-library',
          name: 'company-library',
          component: DocumentList
        },
        {
          path: 'transactions/create/:companyJobKey?',
          name: 'create-transaction',
          component: TransactionNew
        },
        {
          path: 'transactions/:companyJobKey',
          name: 'transactions-details',
          component: TransactionDetails
        },
        {
          path: 'account-settings',
          name: 'account-settings',
          component: AccountSettings
        },
        {
          path: 'carrier-perks',
          name: 'carrier-perks',
          component: CarrierPerks
        }
      ]
    }
  ]
})
